module.exports = __webpack_public_path__ + "img/Poorter_hotel-252.1d2a4c89.jpg";